// extracted by mini-css-extract-plugin
export var featuredContainer = "FeaturedTestimonials-module--featuredContainer--4T2cH";
export var wrapper = "FeaturedTestimonials-module--wrapper--pes3v";
export var cardBody = "FeaturedTestimonials-module--cardBody--r8-6m";
export var title = "FeaturedTestimonials-module--title--rdwrl";
export var description = "FeaturedTestimonials-module--description--TMQtt";